import React, { useEffect } from "react";
import clsx from "clsx";

import styles from "./SelectWarehouse.module.scss";
import partnerWarehouse from "../../apis/partnerWarehouse";
import StorageService from "../../services/StorageService";
import { useNavigate } from "react-router-dom";

export interface SelectWarehouseProps {
  className?: string;
}

const autoLogin = async () => {
  // Do nothing. Use the token generated during Login instead of calling the broken loginHydra API.
};

const checkRefreshToken = async () => {
  const tokenHYDRAInLocal = localStorage.getItem("tokenHYDRA");
  if (tokenHYDRAInLocal) {
    let tokenHYDRA = tokenHYDRAInLocal;
    try {
      // Sometimes it's saved as JSON string, sometimes as raw JWT
      const parsed = JSON.parse(tokenHYDRAInLocal);
      if (parsed && typeof parsed === "string") tokenHYDRA = parsed;
      else if (parsed && parsed.token) tokenHYDRA = parsed.token;
    } catch (e) {
      // If JSON.parse fails, it's likely already a raw JWT string
      tokenHYDRA = tokenHYDRAInLocal;
    }
    
    if (tokenHYDRA && tokenHYDRA.includes(".")) {
      const payloadBase64 = tokenHYDRA.split(".")[1];
      const jwtPayload = JSON.parse(window.atob(payloadBase64));

      const exp = new Date(jwtPayload.exp * 1000);
      const now = new Date();
      if (now > exp) {
        await autoLogin();
      }
    }
  }
};

const SelectWarehouse = (props: SelectWarehouseProps) => {
  const { className } = props;

  const [warehouses, setWarehouses] = React.useState<any>(undefined);

  const navigate = useNavigate();

  useEffect(() => {
    checkRefreshToken();
    try {
      // Instead of getting from localStorage and fallback to JWT, use fixed partnerId:
      let partnerId = process.env.REACT_APP_ENV === "production" ? "01G486CQAV7VW2FK3DHZV1T2FG" : "01G4866BBJGYR1JH8E6RPYEW2C";
      localStorage.setItem("partnerData", JSON.stringify({ id: partnerId }));

      if (partnerId) {
        const param = {
          filter: {
            partnerId: partnerId,
          },
          paging: {
            limit: 100,
            offset: 0,
          },
        };

        const searchPartnerWarehouse = async () => {
          const res = await partnerWarehouse.searchPartnerWarehouse(param);
          const data = res.data.data;
          setWarehouses(data?.userDonations || []);
        };

        searchPartnerWarehouse();
      } else {
        console.error("No partnerId found in localStorage or Token!");
        setWarehouses([]);
      }
    } catch (error) {
      console.error(error);
      setWarehouses([]);
    }
  }, []);

  const handleSelectWarehouse = (item: any) => {
    localStorage.setItem("warehouseData", JSON.stringify(item));
    navigate("/shipping-fee");
  };

  return (
    <div className={clsx(styles.root, className && className)}>
      {warehouses === undefined ? (
        <div className={styles.loading}>
          <div className={styles.loadingIcon}></div>
        </div>
      ) : warehouses?.length > 0 ? (
        <div className={styles.textCenter}>
          <h1 className={styles.title}>Select Warehouse</h1>
          <p className={styles.description}>
            Please select a warehouse to continue
          </p>

          <div className={styles.warehouseSelectWrap}>
            <div className={styles.warehouseSelect}>
              {warehouses?.map((item: any) => {
                return (
                  <div
                    className={styles.warehouseSelectItem}
                    onClick={() => handleSelectWarehouse(item)}
                    key={item?.id}
                  >
                    <div className={styles.warehouseSelectItemIcon}>
                      <img
                        draggable="false"
                        src="/images/warehouse.svg"
                        alt="warehouse"
                      />

                      <div className={styles.warehouseSelectItemIconText}>
                        <p className={styles.warehouseSelectItemIconTextTitle}>
                          {item?.name}
                        </p>
                        <p
                          className={
                            styles.warehouseSelectItemIconTextDescription
                          }
                        >
                          {item?.address?.address}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.textCenter}>
          <h1 className={styles.title}>Không có kho nào</h1>
          <p className={styles.description}>
            Tài khoản này chưa được cấu hình Kho. Vui lòng liên hệ Admin.
          </p>
        </div>
      )}
    </div>
  );
};

export default SelectWarehouse;
